import { useTranslation } from "react-i18next";
import textos from "./textos/Actividades.jsx";

// Pàgina "actividades" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/Actividades.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const Actividades = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__1920x1036__familia-bicicletas-actividades-hotel-camprodon-1678269739.jpeg" className="image-cover image-full c-hero__image" width="100%" height="100%" alt={t("Actividades en Camprodón")} />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{t("Actividades en Camprodón")}</h1>
                                <span className="line max-line-height">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="c-sticky-widget-notifier"></div>
            <section className="c-sticky-widgets d-inline-flex position-relative">
                <div className="c-sticky-widgets--button c-sticky-widgets--booking d-flex-center"><a href={tx.stickyWidgetsButtonHref} className="text-uppercase text-center d-flex-center">{t("Reserva hotel")}</a></div>
                <div className="c-sticky-widgets--button c-sticky-widgets--restaurant d-flex-center"><a href={tx.stickyWidgetsButtonHref2} target="_blank" className="text-uppercase text-center d-flex-center" rel="noopener noreferrer">{t("Reserva restaurante")}</a></div>
            </section>
            <section className="position-relative bg-gray ">
                <div className="c-benefits-slider d-flex-center o-container">
                    <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                    <ul id="draggable-slider" className="c-slider list-style-none m-0 p-0">
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__millor-preu-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Mejor precio garantizado")} />
                            </picture>
                            <div>
                                <span>{t("Mejor precio garantizado")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__reserva-segura-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Reserva segura")} />
                            </picture>
                            <div>
                                <span>{t("Reserva segura")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__confirmacio-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Confirmación inmediata")} />
                            </picture>
                            <div>
                                <span>{t("Confirmación inmediata")}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{t("Actividades en Camprodón")}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                    <p>{tx.presentationContent2}</p>
                </div>
            </section>
            <section className="bg-very-light-gray">
                <div className="c-surroundings-container o-container">
                    <div className="c-section-head c-section-head--light  c-section-head--not-default ">
                        <span className="c-section-head__subtitle text-uppercase color-primary"></span>
                        <h2 className="c-section-head__title">{tx.sectionHeadTitle}</h2>
                        <div className="c-section-head__texts">
                            <p>{tx.sectionHeadTexts}</p>
                        </div>
                    </div>
                    <div className="c-surroundings c-cards-list c-cards-list--vertical ">
                        <div className="c-surroundings__item ">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__personas-senderismo-mirador-hotel-camprodon-1677073976.jpg" alt={tx.surroundingsImgAlt} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">{tx.surroundingsTitle}</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-0">
                                        <p>{tx.readMoreContent}</p>
                                        <p>{tx.readMoreContent2}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-0"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="c-surroundings__item c-surroundings__item--reverse">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__esqui-andorra-hotel-camprodon-1678198066.jpeg" alt={tx.surroundingsImgAlt2} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">{tx.surroundingsTitle2}</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-1">
                                        <p>{tx.readMoreContent3}</p>
                                        <p>{tx.readMoreContent4}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-1"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="c-surroundings__item ">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__puente-personas-rio-caminar-hotel-camprodon-1677073975.jpg" alt={tx.surroundingsImgAlt3} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">{tx.surroundingsTitle3}</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-2">
                                        <p>{tx.readMoreContent5}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-2"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="c-surroundings__item c-surroundings__item--reverse">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__bicicleta-btt-bosque-camino-hotel-camprodon-1678981801.jpeg" alt={tx.surroundingsImgAlt4} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">{tx.surroundingsTitle4}</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-3">
                                        <p>{tx.readMoreContent6}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-3"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="c-surroundings__item ">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__campo-golf-arboles-montanas-hotel-camprodon-1677073976.jpg" alt={tx.surroundingsImgAlt5} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">{tx.surroundingsTitle5}</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-4">
                                        <p>{tx.readMoreContent7}</p>
                                        <p>{tx.readMoreContent8}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-4"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div className="c-surroundings__item c-surroundings__item--reverse">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__573x450__ardilla-tronco-hotel-camprodon-1678981801.jpeg" alt="Molló Parc" className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                            <div className="c-surroundings__content d-flex-center-md">
                                <h3 className="c-surroundings--title">Molló Parc</h3>
                                <div className="c-read-more">
                                    <div className="c-read-more__content" id="read-more-content-5">
                                        <p>{tx.readMoreContent9}</p>
                                        <p>{tx.readMoreContent10}</p>
                                    </div>
                                    <button className="c-read-more__button hc-hidden" id="read-more-button-5"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Actividades;
